<template>
    <div  id="mainDiv">


        <div v-if="TopData.length > 0 " style="margin-top: 2px; padding-left: 5px; color:red;fontSize:16px; background: #ffffff;">
                                <div>置顶</div>
        </div>
        <div  :class=" i==0?'':'margin-top: 1px;' "   v-for="(t,i) in TopData" :key="i">
            <div class="baiseback" :id="'forumItem_'+t.id">

                <el-dropdown class="pull-right" v-if="IisFqz||lander.role=='100'||IisBanzhu" :hide-on-click="true" >
                            <el-button type="primary" :size="webW?'small':'mini'">
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown" >
                                <el-dropdown-item v-if="t.topStart!='0'">
                                    <el-button type="text" icon="el-icon-close"
                                               @click="handleCancelTopbest(i, t,'top')">取消置顶
                                    </el-button>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <div>
                             <table>
                                 <tr>
                                     <td valign="top" :class="webW?'pcutd2':'phoneutd2'" >
                                         <img @click="goUHome(t.authorUid)" :src="t.faceimg"  :class="(webW?'pcavatarTop':'phoneavatarTop') + ' hander'" >
                                     </td>
                                     <td >
                                             <p>
                                             <p><span  :class="webW?'font-size: 16px;font-weight: bold':'font-size: 16px;font-weight: bold'" @click="goForumItem(t,i,'top')">{{t.ftitle}}</span> <el-tag v-if="t.istop=='1'" size="mini">置顶</el-tag>
                                             </p>
                                             
                                             <p> <span @click="goForumItem(t,i,'top')" class="typedesc" >{{t.uname+" "}}</span><span class="typedesc"  @click="goForumItem(t,i,'top')" >发表于  {{t.cts}}</span><span class="typedesc" v-if="t.editTs!=null&&t.editTs!=''">，最后编辑  {{t.editTs}}</span></p>
                                             </p>

                                     </td>
                                 </tr>
                             </table>
                        </div>
            </div>
            <!--pl-->
            <el-collapse-transition>
            <div class="fpldiv" v-if="t.showComments">
                <div class="woo-box-flex">
                  <div class="woo-avatar-main">
                    <img  @click="goUHome(lander.uid)"  class="fplfaceimg hander" :src="$store.state.faceimg" >
                  </div>
                  <div class="woo-box-item-flex">
                    <quill-editor  v-model="t.commentCont"   :options="pleditorOption"   :disabled="nouse|| !ihasReplay" class="fpledit"/>
                  </div>
                </div>
                <div class="Tool_check">
                    <el-button @click="subComment(t,i)" size="mini" round type="warning"   :disabled="nouse|| !ihasReplay">评论</el-button>
                </div>
                <div class="clear">
                    <div class="center" v-if="t.commentliLoading">
                        <img src="../../../assets/img/loading.gif">
                        <p class="typedesc">加载中</p>
                    </div>

                    <div class="center" v-if="!t.commentliLoading&&t.commentli.length==0">
                        <img src="../../../assets/img/zwsj.png" class="zwsjx">
                        <p class="typedesc">暂无数据</p>
                    </div>
                    <div class="fbl_item" v-for="(tc,ic) in t.commentli" :key="ic">
                        <img @click="goUHome(tc.commentUid)" class="fplfaceimg hander" :src="tc.faceimg">
                        <div class="fbl_contsall">

                            <p class="hh fbl_first">
                                <span class="fbl_uname hander" @click="goUHome(tc.commentUid)">{{tc.uname}} </span>
                                <el-tag v-if="tc.istop=='1'" type="danger" size="mini">置顶</el-tag>

                                <span @click="deleteComment(t,i,tc,ic)" v-if="lander.uid== tc.commentUid "
                                      class="pull-right fbl_btnleftline hander">&nbsp;<i class="el-icon-delete"/>删除&nbsp;</span>
                                <span @click="editComment(t,i,tc,ic,1)" v-if="lander.uid== tc.commentUid || IisFqz||lander.role=='100'||IisBanzhu"
                                      class="pull-right fbl_btnleftline hander">&nbsp;<i class="el-icon-edit"/>编辑&nbsp;</span>
                                <span @click="hitComment(t,i,tc,ic,1)"
                                      class="pull-right fbl_btnleftline hander">&nbsp;<i class="fa fa-thumbs-up"/>{{tc.hitNum==0?'点赞':tc.hitNum}}&nbsp;</span>
                                <span @click="replayHandle(t,i,tc,ic,1)" class="pull-right fbl_btnleftline hander">&nbsp;<i
                                        class="el-icon-chat-square"/>回复&nbsp;</span>
                                <span class="fbl_time">{{tc.cts}}</span>

                            </p>

                            <div class="hh  zxplcont margintop5" v-html="tc.cont"></div>


                            <img src="../../../assets/img/reflashing.gif" v-if="tc.hfliLoading" class="suxianing">

                            <div v-if=" tc.hfli.length>0" class="wbpro-list">
                                <div class="fbl_item" v-for="(thf,ihf) in tc.hfli" :key="ihf">
                                    <!-- <img  @click="goUHome(thf.commentUid)" class="fplfaceimg hander" :src="thf.faceimg"> -->
                                    <div class="">

                                        <p class="hh fbl_first">
                                            <span class="fbl_uname hander" @click="replayHandle(t,i,tc,ic,2,thf,ihf)">{{thf.uname}}</span>
                                            <span class="fbl_hfwz">回复</span>
                                            <span class="fbl_uname hander" @click="replayHandle(t,i,tc,ic,3,thf,ihf)">{{thf.hfuname}}</span>
                                            <el-tag v-if="thf.istop=='1'" type="danger" size="mini">置顶</el-tag>

                                            <span @click="deleteCommentReplay(t,i,tc,ic,thf,ihf)"
                                                  v-if="lander.uid== thf.commentUid "
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="el-icon-delete"/>删除&nbsp;</span>
                                            <span @click="editComment(t,i,tc,ic,2,thf,ihf)"
                                                  v-if="lander.uid== thf.commentUid || IisFqz||lander.role=='100'||IisBanzhu"
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="el-icon-edit"/>编辑&nbsp;</span>
                                            <span @click="hitComment(t,i,tc,ic,2,thf,ihf)"
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="fa fa-thumbs-up"/>{{thf.hitNum==0?'点赞':thf.hitNum}}&nbsp;</span>
                                            <span @click="replayHandle(t,i,tc,ic,2,thf,ihf)"
                                                  class="pull-right fbl_btnleftline hander">&nbsp;<i
                                                    class="el-icon-chat-square"/>回复&nbsp;</span>
                                            <span class="fbl_time">{{thf.cts}}</span>

                                        </p>
                                        <div class="hh  zxplcont margintop5" v-html="thf.cont"></div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                 

                </div>
            </div>
            </el-collapse-transition>
            <!--pl-->
        </div>




        <!--置顶,收录 -->
        <el-dialog :title="(topbestData.type=='top'?'设置置顶':'设置收录')+'-'+ topbestData.ftitle " :visible.sync="topbestVisible"  :modal-append-to-body=false    :width="!webW?'99%':'400px'">

            <el-date-picker
                    :class="webW?'':'riqixzqvi'"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    v-model="topbestData.start_end"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>

            <template #footer>


                    <span class="dialog-footer">
                        <el-button @click="topbestVisible = false">取 消</el-button>
                        <el-button type="primary" @click="saveTopbestHnadle">确 定</el-button>
                    </span>
            </template>
        </el-dialog>

        <!--删除 -->
        <el-dialog :title=" ' 删除-'+ delData.ftitle " :visible.sync="delVisible"  :modal-append-to-body=false  :width="!webW?'90%':'50%'">
            <p>请输入删除的原因</p>
            <el-input  v-model="delData.delMsg" type="textarea"/>
            <p>  <el-tag v-for="(t,i) in delMsgli" @click="delData.delMsg=t" :key="i">{{t}}</el-tag></p>

            <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="delVisible = false">取 消</el-button>
                        <el-button type="primary" @click="suredel">确定删除</el-button>
                    </span>
            </template>
        </el-dialog>


    </div>


</template>
<script>
    import {quillEditor, Quill} from 'vue-quill-editor'
    import {ImageExtend} from 'quill-image-extend-module'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import quillEmoji from 'quill-emoji'
    import 'quill-emoji/dist/quill-emoji.css'

    Quill.register('modules/ImageExtend', ImageExtend)
    Quill.register('modules/quillEmoji', quillEmoji)
    import '../../../api/image-paste.min.js';

    import  PubSub from 'pubsub-js'

    import {dealResult, getWindowWidth,forumImgGongge } from '../../../api/common'
    import {
        delForumByManager, saveForumTopBest, getForumDetail
    } from '../../../api';


    import Footer from "../Footer";

    export default {
        name: 'Forum',
        components: {

            quillEditor,
            Footer
        },

        data() {
            const confirmEndDate = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === ""|| str === "0") {
                    callback("请输入结束时间");
                }   else if (str < this.topbestData.start) {
                    callback('结束时间错误!');
                } else {
                    callback();
                }
            };
            return {
                videoplayitemWidth:0,
                nowvideo:{},

                jiugonggeWidth:500,
                jiugonggeItemWidth:0,


                IisFqz:false,
                IisBanzhu:false,

                topbestVisible: false,
                topbestData :{
                    id :'',
                    start_end:[],
                },
                topbestDataIndex:'',



                delMsgli:["广告","心术不正","言辞不雅"],
                delVisible:false,
                delData: {},


                 webW:true,
                votePeopleVisible:false,
                votePeopleQuery:{
                    itemId:'',
                    pageNo:1,
                    pageSize:30,
                },
                votePeopleDataloading:true,
                votePeopleData:[],
                votePeopleDataFinish:false,
                votePeoplePageTotal:0,
                tv:{},




                editCommentVisible: false,
                editCommentData: {},

                replayVisible: false,
                replayUname: '',
                replayCont: '',
                replayData: {},



                nouse: false,//禁用



                lander: {},


                //板块信息
                typeForumLi: [],
                typeForumLiLoading: true,

                typeId: 0,
                typeInfo: {},
                ihasReplay: true,
                ihasRelease: true,

                //帖子信息
                TopData1: [],
                //置顶信息
                TopData: [],


                pleditorOption: {
                    modules: {
                        'emoji-toolbar': true,
                        'emoji-shortname': true,

                        toolbar: {
                            container: ['emoji'],

                        }
                    },
                    //主题
                    theme: "snow",
                    placeholder: "请输入..."

                },

            };
        },
        methods: {
           
            toggle(e) {
                var a = e.target,
                rel = a.getAttribute('rel');
                 this.TopData[rel].hidden = !this.TopData[rel].hidden;
            },


            editDelete(index,row){
                 sessionStorage.managerEditForumFromIndex="1";
                 this.$router.push("ForumDetail?id="+row.id+"&goPosition=top");
            },
            //删除操作
            handleDelete(index,row){
                this.delVisible=true;
                this.delData =row ;
                this.delData.index =index ;
            },
             //移动操作
            handleMove(index,row){
                this.moveVisible=true;
                this.moveData.id =row.id;
                this.moveData.ftitle =row.ftitle;
                this.moveData.typeId =row.typeId;
                this.getTypeList(); 
            },
                suremove(){
                if(this.moveData.typeId==''){
                    this.$message.error('请选择板块');return;
                }
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                    id:this.moveData.id,
                    typeId:this.moveData.typeId
                }
                admin_forum_move(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.moveVisible=false;
                        this.$message.success(res.data.msg);
                        // this.getPage();
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            suredel(){
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:this.topbestData.type,
                    id:this.delData.id,
                    delMsg:this.delData.delMsg,
                }
                delForumByManager(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.delVisible=false;
                        this.$message.success(res.data.msg);
                        this.TopData.splice(this.delData.index,1);
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },

            handleCancelTopbest(index,row,type){
                this.topbestDataIndex=index;

                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:type,
                    start:'0',
                    end:'0',
                    id:row.id,
                }

                // 二次确认
                this.$confirm("确定取消【"+row.ftitle+"】的"+(type=='top'?'置顶？':'收录？'), "提示", {
                    type: "warning",
                }) .then(() => {

                    this.saveTopBest(o);

                });



            },
            handleTopbest(index,row,type){
                this.topbestVisible=true;
                this.topbestData.ftitle=row.ftitle;
                this.topbestData.id=row.id;
                this.topbestData.end='';
                this.topbestData.start='';
                this.topbestData.type=type;

                this.topbestDataIndex=index;

                if(type=='top'){
                    let li=[];
                    if(row.topStart!='0'){
                        this.topbestData.start=row.topStart;
                        li.push(row.topStart);
                    }
                    if(row.topEnd!='0'){
                        this.topbestData.end=row.topEnd;
                        li.push(row.topEnd);
                    }
                    this.topbestData.start_end=li;
                }
                if(type=='best'){
                    let li=[];
                    if(row.bestStart!='0'){
                        this.topbestData.start=row.bestStart;
                        li.push(row.bestStart);
                    }
                    if(row.bestEnd!='0'){
                        this.topbestData.end=row.bestEnd;
                        li.push(row.bestEnd);
                    }

                    this.topbestData.start_end=li;
                }
            },
            //保存操作
            saveTopbestHnadle(){
                // if(this.topbestData.start_end.length==0){
                //     this.$message.info("请选择时间");return;
                // }
                let o={  uid:this.lander.uid,
                    token:this.lander.token,
                    type:this.topbestData.type,
                    start:this.topbestData.start_end[0],
                    end:this.topbestData.start_end[1],
                    id:this.topbestData.id,
                }
                 this.saveTopBest(o);
            },
            saveTopBest(o){
                saveForumTopBest(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1  ) {
                        this.$message.success(res.data.msg)
                        this.topbestVisible = false;

                        this.TopData[this.topbestDataIndex].istop=res.data.obj.istop;
                        this.TopData[this.topbestDataIndex].isbest=res.data.obj.isbest;
                        this.TopData[this.topbestDataIndex].topStart=res.data.obj.topStart;
                        this.TopData[this.topbestDataIndex].topEnd=res.data.obj.topEnd;
                        this.TopData[this.topbestDataIndex].bestStart=res.data.obj.bestStart;
                        this.TopData[this.topbestDataIndex].bestEnd=res.data.obj.bestEnd;
                    }  else {
                        this.$message.error(res.data.msg)
                    }

                })
            },



            goUHome(uid){
                this.$router.push('Home?type=myforum&authorId='+uid);
            },
            goForumItem(t, index, type) {
                this.$router.push('ForumDetail?id=' + t.id + "&goPosition=" + type);
            },

            replayHandle(t, index, tc, ic, type, thf,ihf) {
                if (type == 1) this.replayUname = tc.uname;
                if (type == 2) this.replayUname = thf.uname;
                if (type == 3) this.replayUname = thf.hfuname;
                this.replayVisible = true;
                this.replayData = tc;
                this.replayData.index = index;
                this.replayData.indexc = ic;
                this.replayData.type = type;
                this.replayData.thf = thf;
                this.replayData.ihf = ihf;
                this.replayCont = '';
            },

            getForumDetailFunc(id,index) {
                getForumDetail({uid: this.lander.uid, token: this.lander.token,id: id}).then((res) => {
                    if (res.data.status == 1) {
                        let f=res.data.obj.forumobj;
                        this.TopData[index].ftitle=f.ftitle;
                        this.TopData[index].fcontext=f.fcontext;
                        this.TopData[index].editTs=f.editTs;
                        this.TopData[index].isVote=f.isVote;
                        this.TopData[index].vtype=f.vtype;
                        this.TopData[index].vstartTs=f.vstartTs;
                        this.TopData[index].vendTs=f.vendTs;
                        this.TopData[index].vshowNum=f.vshowNum;
                        this.TopData[index].vshowPeople=f.vshowPeople;
                        this.TopData[index].voteState=f.voteState;
                        this.TopData[index].voteNum=f.voteNum;

                        this.getVoteItemList(index,this.TopData[index]);
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
        },

        created() {
            let windowWidth=getWindowWidth();
            this.webW=(windowWidth>=1000?true:false);

            if(windowWidth>this.jiugonggeWidth){
                this.jiugonggeItemWidth=this.jiugonggeWidth/forumImgGongge-4 ;
            }else{
                this.jiugonggeItemWidth=(windowWidth-30)/forumImgGongge-4 ;
            }
            this.lander = JSON.parse(this.$store.state.logininfo);
            if(this.lander.state!='1'){
                this.nouse=true;
            }

            PubSub.subscribe('forumDataListForTop',(msg,li)=>{
                //这里不写，他请求的还是老的token会过期，原因不明
                this.lander = JSON.parse(this.$store.state.logininfo);

                if(li!=null){
                    let endindex=this.TopData.length;
                    this.TopData= this.TopData.concat(li);

                    for(let i=endindex;i<this.TopData.length;i++){
                        if(this.TopData[i].isVote=='1')this.getVoteItemList(i,this.TopData[i]);
                    }
                   

                   

                }else{
                    this.TopData=[];
                }

            });
            // PubSub.subscribe('forumDataListForNewPub',(msg,li)=>{
            //     //这里不写，他请求的还是老的token会过期，原因不明
            //     this.lander = JSON.parse(this.$store.state.logininfo);

            //     if(li!=null){
            //         let endindex=this.TopData.length;
            //         this.TopData= this.TopData.concat(li);

            //         for(let i=endindex;i<this.TopData.length;i++){
            //             if(this.TopData[i].isVote=='1')this.getVoteItemList(i,this.TopData[i]);
            //         }
                   

                   

            //     }else{
            //         this.TopData=[];
            //     }

            // });
            PubSub.subscribe('delFormListIndex',(msg,id)=>{
                let  index = ( this.TopData || []).findIndex((item) => item.id === id);
                if(index>=0)this.TopData.splice(index,1);

            });
            PubSub.subscribe('editFormListIndex',(msg,id)=>{
                let  index = ( this.TopData || []).findIndex((item) => item.id === id);
                if(index>=0) {
                   this.getForumDetailFunc(id,index);
                }

            });
            PubSub.subscribe('typeAndQx',(msg,obj)=>{
                this.typeInfo=obj;
                this.ihasReplay=obj.ihasReplay;
                this.ihasReplay=obj.ihasReplay;
                this.typeId=obj.id;

            });
            PubSub.subscribe('IcanManageForumIndex',(msg,boo)=>{
               this.IisFqz =boo;

            });

            PubSub.subscribe('IisBanzhuFromIndex',(msg,boo)=>{
                this.IisBanzhu =boo;

            });
        },
        activated() {

        },
        deactivated() {
            
        }

    };
</script>
<style scoped>

 /deep/ .ql-container {
       min-height:34.71px;
   }



.Tool_check {
    position: relative;
    top: -10px;
    right: 13px;
    float: right;
}
   .fpledit {
     display: flex;
     width: 100%;
     flex-direction:column-reverse
   }
   .fpledit /deep/ .ql-container.ql-snow {
     border:0;
   }
   .fpledit /deep/ .ql-toolbar.ql-snow {
     border:0;
     background: none;
   }
   .fpledit /deep/ .ql-toolbar.ql-snow .ql-fill{
     color:red;
   }
   .fpledit /deep/ .ql-toolbar.ql-snow .ql-formats .ql-emoji {
     height: 3.5rem;
   }
   .fpledit /deep/ .ql-container .ql-editor {
       padding:6px 11px;
       font-size: 16px;
       word-break:break-all;
       white-space:normal;
   }

   .fpledit /deep/ .ql-container {
       background: #ffffff;

       padding: 0 0;
       width: 100%;
   }
   .fpledit /deep/ .ql-toolbar {
       width:50px;
       height:40px;
       margin-left: 10px;
       background: #ffffff;

   }

    .el-checkbox-group {
        font-size: 13px;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }

.riqixzqvi{transform: scale(0.8);margin-left: -20px;}
</style>
